<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/service.png" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-7">
                <h4 class="primary-color font-600">
                  {{ $t("text.bServices.title") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.bServices.description") }}
                  {{ branch ? branch.name : "" }} h{{
                    $t("text.bServices.here")
                  }}
                </p>
              </div>
              <div class="col-md-4 flexify">
                <router-link
                  :to="{
                    name: 'TransactionServices',
                    query: { ...$route.query },
                  }"
                  class="mr-3 btn dealers_btn"
                  >{{ $t("text.bServices.manageTransaction") }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.bServices.totalServices") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/service.png" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ this.totalSupplies }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>
                <e-column
                  width="159"
                  field="name"
                  :headerText="$t('text.bServices.serviceName')"
                ></e-column>
                <e-column
                  width="150"
                  field="serviceDescription"
                  :headerText="$t('text.bServices.serviceDescription')"
                ></e-column>
                <e-column
                  width="350"
                  :template="template"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
// import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
// import UserStatusTemp from "@/components/Templates/userStatusTemp";
// import AddOldUserModal from "@/components/modals/addOldUser";
// import Template from "@/components/Templates/NonWetProducts/supply";
import Template from "@/components/Templates/services/branchServices";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Non Wet Products :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
    // AddOldUserModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branch: null,
      backgroundUrl,
      salesCount: 0,
      cardBackgroundUrl,
      showLoader: true,
      totalSupplies: 0,
      users: [],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
      template: function () {
        return {
          template: Template,
        };
      },
    };
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getServices();
        }
      }
    },
  },
  created() {
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Services :: ${branch.name} Retail Outlet`;
    });
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    // openModal($modal) {
    //   this.$modal.show($modal);
    // },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Services.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.getColumns()[4].visible = false;
          this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    rowDataBound: function (args) {
      if (args.data["isSupplyAccepted"] === "Yes") {
        args.row.cells[6].style.color = "green";
      } else {
        args.row.cells[6].style.color = "red";
      }
    },
    getServices() {
      this.showLoader = true;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/Service/CompanyServices/${
            this.branch ? this.branch.companyId : this.$route.query.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.totalSupplies = response.data.length;
          this.showLoader = false;
          response.data.forEach((el, i) => {
            el.serviceDescription = el.serviceDescription
              ? el.serviceDescription
              : "N/A";
            el.index = i + 1;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
